// DEV FIXTURE DATA — used only in non-production dev/design-preview mode
// (see component.js's isNonProdEnv gate) when no real result is available.
// The content payload (ALL_CONTENT) is always real and fetched live.
//
// The real /result endpoint returns only `userTraits: [{score, percentage,
// trait: {title}}]` — no `overall` object exists on the real result at
// all. Every derived value (raw/max/bandKey/psychometric/Consistency) is
// computed by report-model.js from `score`/`percentage` alone — nothing
// here is hand-authored. Shape mirrors the real `userTraits` field
// name/structure so report-model.js has exactly one code path for real
// and fixture data.
//
// Backend contract (2026-09-17): score is the authoritative raw
// correct-answer count for the section (an integer, 0-15) and percentage
// is the independent, backend-calculated percentage — neither is derived
// from the other. Kept as two separate, mutually-consistent numbers here
// purely because that's what a real result looks like.

import { IQ_TEST_ASSESSMENT_ID } from "../../utils/general-config";

export const MOCK_ASSESSMENT_RESULT = {
  // Read directly by ShareButton/SendToFriendButton off the raw result.
  id: "dev-fixture-attempt-id",
  assessmentAttemptId: "dev-fixture-attempt-id",
  assessmentId: IQ_TEST_ASSESSMENT_ID,
  assessmentTitle: "IQ Test",
  personality: { role: "" }, // IQ has no personality-type concept; kept neutral so these components don't throw on a missing field

  userTraits: [
    { score: 12, percentage: 80, trait: { title: "pattern_recognition" } },
    { score: 11, percentage: 73, trait: { title: "verbal_reasoning" } },
    { score: 10, percentage: 67, trait: { title: "numerical_reasoning" } },
    { score: 11, percentage: 73, trait: { title: "logical_deduction" } },
  ],
};
